import { render, staticRenderFns } from "./ProjectDeliveryRequestForMaterials.vue?vue&type=template&id=50e4a925&"
import script from "./ProjectDeliveryRequestForMaterials.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliveryRequestForMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports